import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import AddNewSectionV2 from './AddNewSectionV2';
import EditSection from './EditSection';

const SectionSetupLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ClassSetup' */ './components/SectionSetup')
);

export default (store) => {
	return [
		{
			path: 'section-setup/:campusId?',
			element: <AsyncLoading component={<SectionSetupLazy />} />,
		},
		AddNewSectionV2(store),
		EditSection(store),
	];
};
